var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from '../order/order.service';
import { CurrentOrderService } from '../order/currentOrder.service';
var QrComponent = (function () {
    function QrComponent(router, orderService, currentOrderService) {
        this.router = router;
        this.orderService = orderService;
        this.currentOrderService = currentOrderService;
        this.codeQr = "";
    }
    QrComponent.prototype.search = function (val) {
        var _this = this;
        this.codeQr = val;
        var part = JSON.parse(window.atob(this.codeQr))['part'];
        var order = JSON.parse(window.atob(this.codeQr))['order'];
        console.log("part# : ", part, " order# : ", order);
        this.orderService.getOrder(order).subscribe(function (data) {
            console.log(data);
            for (var i = 0; i < data.Items.length; i++) {
                if (data.Items[i].PartNumber == part) {
                    var p = data.Items[i];
                    data.Items = [];
                    data.Items.push(p);
                    break;
                }
            }
            data.PurchaseOrderNumber = "";
            data.ShippingAddress.Country.Id = "8b8b29a8-0e25-40fa-9004-8482c49daa5f"; //canada
            _this.currentOrderService.setOrder(data);
            _this.router.navigate(['/order/part']);
        });
    };
    QrComponent = __decorate([
        Component({
            selector: 'cx-orderaddress',
            templateUrl: './qr.component.html',
        }),
        __metadata("design:paramtypes", [Router, OrderService,
            CurrentOrderService])
    ], QrComponent);
    return QrComponent;
}());
export { QrComponent };
//# sourceMappingURL=qrcomponent.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/QR/qrcomponent.component.js
// module id = 264
// module chunks = 0